export const compareAlphabetically = (
  candidateA: null | string | undefined,
  candidateB: null | string | undefined
) => {
  const normalizedValueA = (candidateA ?? '').toLowerCase();
  const normalizedValueB = (candidateB ?? '').toLowerCase();

  if (normalizedValueA < normalizedValueB) {
    return -1;
  }

  if (normalizedValueA > normalizedValueB) {
    return 1;
  }

  return 0;
};
